import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { ConfirmDialogModule, CalendarModule, FileUploadModule, DialogModule, RadioButtonModule, DataTableModule } from 'primeng/primeng';

import { Ng2BRPipesModule } from 'ng2-brpipes';

import { EmpregoNaPistaSharedModule } from '../shared/emprego-na-pista-shared.module';

import { EtapaRouting } from './etapa.routing';

import { AnalisarDocumentacaoComponent } from './analisar-documentacao/analisar-documentacao.component';
import { ConvocarAlunoComponent } from './convocar-aluno/convocar-aluno.component';
import { GerenciarEtapasComponent } from './gerenciar-etapas/gerenciar-etapas.component';

import { CandidatoAprovadoService } from '../../services/candidato-aprovado.service';
import { MotivoCandidatoReprovadoService } from '../../services/motivo-candidato-reprovado.service';
import { CandidatoReprovadoService } from '../../services/candidato-reprovado.service';
import { CursoEspecializadoService } from '../../services/curso-especializado.service';


@NgModule({
    imports: [
        BrowserModule,
        FormsModule, ReactiveFormsModule,

        EtapaRouting,

        ConfirmDialogModule, CalendarModule, FileUploadModule, DialogModule, RadioButtonModule, DataTableModule,

        Ng2BRPipesModule,

        EmpregoNaPistaSharedModule
    ],
    providers: [ CandidatoAprovadoService, MotivoCandidatoReprovadoService, CandidatoReprovadoService , CursoEspecializadoService],
    declarations: [
        AnalisarDocumentacaoComponent,
        ConvocarAlunoComponent,
        GerenciarEtapasComponent,
    ],
})
export class EtapaModule { }



// WEBPACK FOOTER //
// ./src/app/components/etapa/etapa.module.ts